// stores/bottom-sheet.store.ts
'use client';

import { create } from 'zustand';

type BottomSheetState = {
  isOpen: boolean;
  content: 'list' | 'empty';
  openSheet: (type: 'list' | 'empty') => void;
  closeSheet: () => void;
  onCloseCallback: (() => void) | null;
  setOnCloseCallback: (callback: (() => void) | null) => void;
};

export const useBottomSheetStore = create<BottomSheetState>((set) => ({
  isOpen: false,
  content: 'list', // 기본값을 명확히 설정
  onCloseCallback: null,
  openSheet: (type: 'list' | 'empty') => set({ isOpen: true, content: type }),
  closeSheet: () => {
    const { onCloseCallback } = useBottomSheetStore.getState();
    if (onCloseCallback) {
      onCloseCallback();
    }
    set({ isOpen: false });
  },
  setOnCloseCallback: (callback) => set({ onCloseCallback: callback }),
}));
